import useResource from "web/hooks/data/useResource"

export default function useImport(id, swrOptions = {}) {
  const key = `/imports/${id}`
  const [data] = useResource({ key, swrOptions })

  data.swrKey = key

  return data
}
